// Simple pub/sub stores for customer + admin auth and cart. No zustand — keeps deps minimal.
import { useEffect, useState } from "react";

function makeStore(key) {
  const listeners = new Set();
  const load = () => {
    try {
      return JSON.parse(localStorage.getItem(key) || "null");
    } catch {
      return null;
    }
  };
  let state = load();
  return {
    get: () => state,
    set: (val) => {
      state = val;
      if (val) localStorage.setItem(key, JSON.stringify(val));
      else localStorage.removeItem(key);
      listeners.forEach((l) => l(state));
    },
    subscribe: (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
  };
}

export const authStore = makeStore("qrdine_auth");
export const adminAuthStore = makeStore("qrdine_admin_auth");

export function useAuth() {
  const [s, setS] = useState(authStore.get());
  useEffect(() => authStore.subscribe(setS), []);
  return s;
}
export function useAdminAuth() {
  const [s, setS] = useState(adminAuthStore.get());
  useEffect(() => adminAuthStore.subscribe(setS), []);
  return s;
}

export function setCustomerAuth(payload) {
  if (payload) localStorage.setItem("qrdine_token", payload.token);
  else localStorage.removeItem("qrdine_token");
  authStore.set(payload);
}
export function setAdminAuth(payload) {
  if (payload) {
    localStorage.setItem("qrdine_admin_token", payload.token);
    const rids = payload.user?.restaurant_ids || [];
    if (rids.length) localStorage.setItem("qrdine_active_restaurant", rids[0]);
  } else {
    localStorage.removeItem("qrdine_admin_token");
    localStorage.removeItem("qrdine_active_restaurant");
  }
  adminAuthStore.set(payload);
}
